import React from 'react';
import { urls } from '../../logic/urls';

export const PageNotFound = (props) =>(
  <div>
    <p>The page you have requested does not exist</p> 
    <a href={urls.home}>Home</a>
    <div>Current location: {props.location.pathname}</div>
  </div>
)